import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { competencyListSevice } from '../../_services/Analyze/competencyList.service';

export const competencyListAction = {
    competencyListDataAction
}


function competencyListDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        competencyListSevice.competencyListData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                    callBack != undefined ? callBack(error) : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_COMPETENCY_LIST } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_COMPETENCY_LIST, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_COMPETENCY_LIST, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/competencyList.action.js